module.exports = __webpack_public_path__ + "img/ringProfile.d88f077.jpg";